<div class="umkt-highlight-card-group">
  <article class="umkt-highlight-card" *ngFor="let _ of cardIndexes">
    <div class="umkt-highlight-card__header">
      <div class="umkt-highlight-card__icon" *ngIf="shouldRenderIconComponent || shouldRenderIconClass || shouldRenderIconSvg">
        <ng-container *ngIf="shouldRenderIconComponent">
          <i
            *ngIf="icon?.type === 'material-icons'"
            class="material-icons"
            [attr.aria-label]="icon?.name"
          >
            {{ icon?.name }}
          </i>
          <umkt-icon
            *ngIf="icon?.type !== 'material-icons'"
            [icon]="icon"
          >
          </umkt-icon>
        </ng-container>
        <span
          *ngIf="shouldRenderIconClass"
          [class]="iconClass"
          [attr.aria-label]="iconAriaLabel"
        ></span>
        <span
          class="umkt-highlight-card__icon-svg"
          *ngIf="shouldRenderIconSvg"
          [innerHTML]="sanitizedIconSvg"
          [attr.aria-label]="iconAriaLabel"
        ></span>
      </div>
      <h3 class="umkt-highlight-card__title">
        {{ titleKey ? (titleKey | i18n) : title }}
      </h3>
    </div>
    <p class="umkt-highlight-card__subtitle">
      {{ subtitleKey ? (subtitleKey | i18n) : subtitle }}
    </p>
  </article>
</div>

